import type {
    OpenWhenLetter,
    QuizQuestion,
    SectionMap,
    SettingsRow
} from '@/types'

import { cn } from '@/lib/utils'

import CakeGame from '@/components/landing/cake-game'
import LoveQuiz from '@/components/landing/love-quiz'
import OpenWhen from '@/components/landing/open-when'
import Reveal from '@/components/landing/reveal'
import SectionHeading from '@/components/landing/section-heading'

interface GamesSectionProps {
    sections: SectionMap
    settings: SettingsRow | null
    quiz: Array<QuizQuestion>
    openWhen: Array<OpenWhenLetter>
}

export default function GamesSection({ sections, settings, quiz, openWhen }: GamesSectionProps) {
    const hasQuiz = quiz.length > 0

    return (
        <section id='games' className='relative overflow-hidden bg-gradient-to-b from-cream via-[#fff3f0] to-blush/70 py-24 sm:py-32'>
            <div aria-hidden className='absolute top-40 -left-40 size-96 rounded-full bg-[#ffe3d1] blur-3xl' />

            <div className='relative mx-auto max-w-6xl px-6 lg:px-10'>
                <SectionHeading section={sections.games} />

                <div className='mt-14 grid gap-6 sm:mt-16 lg:grid-cols-2 lg:gap-8'>
                    <Reveal className={cn(!hasQuiz && 'lg:col-span-2')}>
                        <CakeGame section={sections.cake} settings={settings} />
                    </Reveal>

                    {hasQuiz && (
                        <Reveal delay={120} className='flex [&>*]:flex-1'>
                            <LoveQuiz section={sections.quiz} questions={quiz} />
                        </Reveal>
                    )}
                </div>

                {openWhen.length > 0 && (
                    <Reveal className='mt-6 lg:mt-8'>
                        <OpenWhen section={sections.open_when} letters={openWhen} />
                    </Reveal>
                )}
            </div>
        </section>
    )
}
